import { render, staticRenderFns } from "./questionBankUpdate.vue?vue&type=template&id=1c01fcaf&scoped=true&"
import script from "./questionBankUpdate.vue?vue&type=script&lang=js&"
export * from "./questionBankUpdate.vue?vue&type=script&lang=js&"
import style0 from "./questionBankUpdate.vue?vue&type=style&index=0&id=1c01fcaf&prod&lang=scss&scoped=true&"
import style1 from "./questionBankUpdate.vue?vue&type=style&index=1&id=1c01fcaf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c01fcaf",
  null
  
)

export default component.exports